import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { switchMap } from 'rxjs/operators';

import { AccountingService } from '@shared/http/accountings.service';
import { ZproService } from '@shared/services/zpro.service';
import { UserService } from '@shared/http/users.service';
import { User } from '@shared/models/User';
import { ShortcutService } from '@shared/services/shortcut.service';
import { DialogService } from '@shared/services/dialog.service';
import { filter } from 'rxjs/operators';
import { CompanyService } from '@shared/http/company.service';
import { Company } from '@shared/models/Company';
import { Router } from '@angular/router';
import { Organization } from '@shared/models/Organization';
import { ExternalAccoutingConfirmationComponent } from '@shared/dialogs/external-accouting-confirmation/external-accouting-confirmation.component';
import { environment } from '@env';
import { interval, Subscription } from 'rxjs';
import { NewsletterService } from '@shared/services/newsletter.service';
import { SigninAsDialogComponent } from '@shared/components/dialogs/signin-as-dialog/signin-as-dialog.component';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss']
})
export class ContentLayoutComponent implements OnInit, AfterViewInit, OnDestroy {

  public showChat = true;
  public chatInitialized = false;
  // Mensagens do chat ainda não vistas (número exibido no botão "Peça ajuda de um especialista")
  public naoLidas = 0;
  private naoLidasSubscription: Subscription;

  constructor(
    public userService: UserService,
    private oicAccountingService: AccountingService,
    private zpro: ZproService,
    private shortcuts: ShortcutService,
    private dialog: DialogService,
    private companies: CompanyService,
    private router: Router,
    private headway: NewsletterService
  ) { }

  ngAfterViewInit(): void {
    this.popNewsletter();
  }

  private popNewsletter() {
    // this.headway.showOn('#newsletter-container');
  }

  ngOnDestroy(): void {
    this.naoLidasSubscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.naoLidasSubscription = this.zpro.naoLidas$.subscribe(quantidade => this.naoLidas = quantidade);
    this.zpro.registerSession().subscribe();
    this.zpro.init().subscribe(() => {
      this.chatInitialized = true;
      console.log('ZPRO started');
    });
    this.userService.confirmLogin().subscribe();
    this.updateOicAccounting();
    this.setShortcuts();
    if (environment.production) {
      this.verifyAccounting();
    }
    this.keepAccountingUpdated();

  }

  private updateOicAccounting() {
    const user = User.fromLocalStorage();
    // this.oicAccountingService.fetchByOauthId(user.organization.id)
    // .pipe(switchMap(result => this.oicAccountingService.updateAccounting(result.record)))
    // .subscribe(result => {
    //   this.showChat = !result.record.chatBloqueado;
    //   user.organization.chatBloqueado = result.record.chatBloqueado ?? false;
    //   user.organization.chaveDeAcesso = result.record.chaveDeAcesso || '';
    //   user.organization.classificacao = result.record.classificacao || '';
    //   user.organization.perfil = result.record.perfil || '';
    //   user.organization.sistemaContabil = result.record.sistemaContabil || '';
    //   this.showChat = !user.organization.chatBloqueado;
    //   const json = JSON.stringify(user);
    //   localStorage.setItem('user-info', json);
    // });
  }

  private verifyAccounting() {
    const user = User.fromLocalStorage();
    if (user.type === User.Type.ADMINISTRATOR && user.organization.cnpj !== Organization.CNPJ_OTTIMIZZA) {
      this.dialog.open(ExternalAccoutingConfirmationComponent);
    }
  }

  private setShortcuts() {
    this.shortcuts.listen('help').subscribe(() => {
      this.toggleZpro();
    })

    this.shortcuts.listen('ajuda').subscribe(() => {
      this.toggleZpro();
    })

    if (User.fromLocalStorage().type === User.Type.ADMINISTRATOR) {
      this.shortcuts.listen('0', { alt: true }).subscribe(() => {
        this.dialog.open(SigninAsDialogComponent)
      });
    }
  }

  toggleZpro() {
    this.zpro.toggleChat();
  }

  private keepAccountingUpdated() {
    let user = User.fromLocalStorage();
    if (user.type === User.Type.ADMINISTRATOR) {
      interval(120 * 1000)
      .pipe(switchMap(() => this.userService.fetchById(user.id)))
      .subscribe(result => {
        user = User.fromLocalStorage();
        if (result.record.organization.id !== user.organization.id) {
          window.location.reload();
        }
      });
    }
  }

}
